// La empresa entra por /<empresa> (ej. /fuegoburger) y ese prefijo se mantiene en
// toda la navegación (/fuegoburger/player, /fuegoburger/login, ...) usándolo como
// `base` del router. Se calcula una sola vez, al cargar la página.
//
// Debe mantenerse en sincronía con RESERVED_SLUGS del admin
// (dev_adm_pantallas/api/controllers/credentialsControllers.js): son las rutas y
// carpetas de archivos que NO pueden ser una empresa. La BD es compartida, así
// que el admin es quien impide crear una empresa con uno de estos nombres.
const RUTAS_RESERVADAS = [
    'login', 'home', 'player', 'usertest', 'api', 'empresa-requerida', 'assets',
    'js', 'css', 'img', 'fonts', 'offline-content'
];

const primerSegmento = window.location.pathname.split('/')[1] || '';

export const empresaBase =
    /^[a-z0-9-]+$/.test(primerSegmento) && !RUTAS_RESERVADAS.includes(primerSegmento)
        ? primerSegmento
        : '';
